import { Component, Input } from '@angular/core';

@Component({
  selector: 'chevron',
  template: `
    <span class="chevron chevron--{{direction || 'down'}}">
      <svg-icon class="sicon--inline sicon--color-current sicon--1em" name="icon-chevron-down"></svg-icon>
    </span>
  `,
})
export class ChevronComponent {

  @Input() direction: string;

  constructor() { }
}

export enum EDirection {
  up = 'up',
  down = 'down',
  left = 'left',
  right = 'right'
}
